/* eslint-disable */

import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../config.js';
import Table from '../../../commons/Table/Table';
import Modal from '../../../commons/Modal/Modal';
import { TypeaheadInput } from '../../../commons/Inputs';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';

let App = window.App;
let Handlebars = window.Handlebars;
let $ = window.jQuery;

export default class Index extends Component {

    state = {
        prescriptionTemplates: [],
        dosage: '',
        brand: '',
        generic: '',
        isSaving: false,
        headers : [
            {key : 'generic', label : 'Generic'},
            {key : 'brand', label : 'Brand'},
            {key : 'dosage', label : 'Dosage'},
            {key : 'actions', label : 'Actions'},
            {key : 'id', label: 'id'}
        ]
    };

    handleFABClick = () => {
        $('#prescriptionTemplateModal').modal('show');
    };

    generateTableActions = (id) => {
        let html = (
            <div className="">
                <button href="#"
                        className='btn btn-xs tooltips blue'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Edit'
                        onClick={this.handleEditAccount}
                        data-id={id}>

                    <i className='glyphicon glyphicon-edit'
                       data-id={id} />
                </button>
                <button href="#"
                        className='btn btn-xs tooltips deletePopover red'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Delete'
                        data-id={id}
                        data-toggle="confirmation"
                        data-singleton="true">

                    <i className='glyphicon glyphicon-remove'
                       data-id={id} />
                </button>
            </div>
        );

        return html;
    };

    getPrescriptionTemplates = () => {
        let url = config.apiUrl + 'prescription-templates';

        axios.get(url).then((res) => {
            let displayData = res.data.data;

            displayData.forEach((row) => {
                // add actions
                row.actions = this.generateTableActions(row.id);
            });

            this.setState({
                prescriptionTemplates: displayData
            }, () => {
                $('#prescriptionTemplateTable').DataTable({
                    "columnDefs": [
                        {
                            "targets": [4], //id
                            "visible": false,
                            "searchable": false
                        },
                        {
                            "targets": [3],
                            "width": 100
                        }
                    ],
                    "order": [[ 4, 'desc' ]]
                });

                $('.tooltips').tooltip();

                let self = this;

                $('.deletePopover').confirmation({
                    title: 'Are you sure to delete this Prescription Template?',
                    popout: true,
                    btnOkClass: 'btn btn-primary btn-sm',
                    btnCancelClass: 'btn btn-danger btn-sm',
                    container: 'body',
                    onConfirm: function() {
                        let templateId = $(this).data('id');
                        self.deletePrescriptionTemplate(templateId);
                    }
                });
            });
        }).catch((error) => {
            // Display error
            console.log(error);
        });
    };

    handleSavePrescriptionTemplate = () => {
        this.setState({
            isSaving: true
        });

        let data = {
            dosage: this.state.dosage,
            generic: this.state.generic,
            brand: this.state.brand
        };

        console.log(data);

        let url = `${config.apiUrl}prescription-templates`;

        axios.post(url, data).then((res) => {
            this.setState({
                isSaving: false
            });

            // App.alert({
            //     container: '#alert-modal-container-pt', // alerts parent container(by default placed after the page breadcrumbs)
            //     place: 'append', // append or prepent in container
            //     type: 'success',  // alert's type
            //     message: 'Prescription Template is saved successfully',  // alert's message
            //     close: '1', // make alert closable
            //     reset: '1', // close all previouse alerts first
            //     focus: '1', // auto scroll to the alert after shown
            //     closeInSeconds: '10', // auto close after defined seconds
            //     icon: 'check' // put icon before the message
            // });

            $('#prescriptionTemplateTable').dataTable().fnDestroy();
            $('#prescriptionTemplateModal').modal('hide');
            this.getPrescriptionTemplates();

            this.clearForm();
        }).catch((error) => {
            this.setState({
                isSaving: false
            });

            // App.alert({
            //     container: '#alert-modal-container-pt', // alerts parent container(by default placed after the page breadcrumbs)
            //     place: 'append', // append or prepent in container
            //     type: 'danger',  // alert's type
            //     message: 'Oops. Something went wrong',  // alert's message
            //     close: '1', // make alert closable
            //     reset: '1', // close all previouse alerts first
            //     focus: '1', // auto scroll to the alert after shown
            //     closeInSeconds: '10', // auto close after defined seconds
            //     icon: 'warning' // put icon before the message
            // });

            console.log(error);

            this.clearForm();
        })
    };

    handleEditAccount = (e) => {

    };

    deletePrescriptionTemplate = (id) => {

    };

    handleCloseModal = () => {
        this.clearForm();
    };

    clearForm = () => {
        this.setState({
            dosage: '',
            brand: '',
            generic: ''
        }, () => {
            console.log(this.state);
        });
    };

    handleSelectedGeneric = (data) => {
        if (typeof data === 'object') {
            this.setState(data);
        } else {
            this.setState({
                generic: data
            });
        }
    };

    handleSelectedBrand = (data) => {
        if (typeof data === 'object') {
            this.setState(data);
        } else {
            this.setState({
                brand: data
            });
        }
    };

    handleSelectedDosage = (data) => {
        if (typeof data === 'object') {
            this.setState(data);
        } else {
            this.setState({
                dosage: data
            });
        }
    };

    componentDidMount() {
        this.getPrescriptionTemplates();
    }

    render() {
        let genericSuggestionTemplate = Handlebars.compile([
                '<div class="media-body">',
                    '<h4 class="media-heading">{{generic}}</h4>',
                '</div>',
                '</div>'
            ].join(''));

        let brandSuggestionTemplate = Handlebars.compile([
            '<div class="media-body">',
            '<h4 class="media-heading">{{brand}}</h4>',
            '</div>',
            '</div>'
        ].join(''));

        let dosageSuggestionTemplate = Handlebars.compile([
            '<div class="media-body">',
            '<h4 class="media-heading">{{dosage}}</h4>',
            '</div>',
            '</div>'
        ].join(''));

        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-8">
                        <h3 className="page-title">
                            Management &nbsp; <small>Prescription Templates</small>
                        </h3>
                    </div>
                </div>

                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="portlet light portlet-fit">
                        <div className="portlet-title">
                            <div className="caption">
                                <i className="fa fa-medkit font-blue" />
                                <span className="caption-subject font-blue sbold uppercase">
                                    Prescription Templates</span>
                            </div>
                        </div>
                        <div className="portlet-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-scrollable">
                                        <Table id={"prescriptionTemplateTable"} headers={this.state.headers}
                                               data={this.state.prescriptionTemplates} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <FloatingActionButton
                            title="Add Prescription Template"
                            onClick={this.handleFABClick} />
                    </div>
                </div>

                <Modal
                    id="prescriptionTemplateModal"
                    header="Prescription Template"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSavePrescriptionTemplate}
                    isSaving={this.state.isSaving}>

                    <div className="row">
                        <div id="alert-modal-container-pt"
                             style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                        <div className="col-md-12">
                            <form id="accountForm">
                                <div className="row">
                                    <div className="col-md-4 col-sm-12 col-xs-12">
                                        <TypeaheadInput val={this.state.generic} id="generic"
                                                        onChange={e => this.setState({generic: e.target.value})}
                                                        label="Generic Name *" help="Input generic name"
                                                        handleSelectedData={this.handleSelectedGeneric}
                                                        emptySearchText=""
                                                        suggestionListTemplate={genericSuggestionTemplate}
                                                        searchURL="prescription-templates/generics"
                                                        typeAheadName="generics"
                                                        display="generic" />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12">
                                        <TypeaheadInput val={this.state.brand} id="brand"
                                                        onChange={e => this.setState({brand: e.target.value})}
                                                        label="Brand Name *" help="Input brand name"
                                                        handleSelectedData={this.handleSelectedBrand}
                                                        emptySearchText=""
                                                        suggestionListTemplate={brandSuggestionTemplate}
                                                        searchURL="prescription-templates/brands"
                                                        typeAheadName="brands"
                                                        display="brand" />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12">
                                        <TypeaheadInput val={this.state.dosage} id="dosage"
                                                        onChange={e => this.setState({dosage: e.target.value})}
                                                        label="Dosage *" help="Input dosage"
                                                        handleSelectedData={this.handleSelectedDosage}
                                                        emptySearchText=""
                                                        suggestionListTemplate={dosageSuggestionTemplate}
                                                        searchURL="prescription-templates/dosages"
                                                        typeAheadName="dosages"
                                                        display="dosage" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/prescriptionTemplates/Index.js
 **/